import { Injectable } from '@angular/core';
import { MathUtils } from 'three';
import { AnnotationOutput } from '../../../team-apis/otterdam/outputs/annotation-output';
import { CuboidHelper } from '../mesh/cuboid/cuboid-helper';
import {
  AbstractShortcutTransformService,
  getShortcutNameWithoutTransformModifier,
  shouldDoSmallTransform,
} from './abstract-shortcut-transform.service';
import { RotationShortcut, rotationShortcuts } from './transform-shortcuts';

@Injectable()
export class ShortcutRotationService extends AbstractShortcutTransformService {
  constructor() {
    super(rotationShortcuts);
  }

  // eslint-disable-next-line complexity -- we need two cases per X, Y, Z axis,complexity
  protected transformCuboid(
    cuboid: CuboidHelper,
    shortcut: RotationShortcut,
    sourceOutput: AnnotationOutput,
  ) {
    const stepSize = MathUtils.degToRad(
      shouldDoSmallTransform(shortcut) ? 1 : 5,
    );
    switch (getShortcutNameWithoutTransformModifier(shortcut)) {
      case 'yawLeft':
        cuboid.box.rotateZ(stepSize);
        break;
      case 'yawRight':
        cuboid.box.rotateZ(-stepSize);
        break;
      case 'pitchLeft':
        cuboid.box.rotateX(-stepSize);
        break;
      case 'pitchRight':
        cuboid.box.rotateX(stepSize);
        break;
      case 'rollLeft':
        cuboid.box.rotateY(stepSize);
        break;
      case 'rollRight':
        cuboid.box.rotateY(-stepSize);
    }

    this.store.updateFocusedLocationFromCuboidMesh(cuboid.box);
    this.trackTransform(cuboid, shortcut, 'rotate', sourceOutput);
  }
}
